import React from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import Photo from '../Photo';
import { CornerblockCta } from './Cta';
import { CornerblockWYSIWYG } from './WYSIWYG';
import CdnImage from '../../common/CdnImage';
import Utils from '../../../common/Utils';

const Cornerblock = ({ backgroundColor, contentItems, followContentLink = () => {}, nodeTypeAlias = 'Cornerblock', refs, renderSingle, textColor, width }) => {
    const renderContentItem = contentItem => {
        if (contentItem.nodeTypeAlias.equals('reactCornerBlockCTA')) {
            const { key, ...props } = contentItem;
            return (
                <CornerblockCta
                    key={key}
                    {...props}
                    backgroundColor={Utils.applyColor(backgroundColor)}
                    textColor={Utils.applyColor(textColor)}
                    followContentLink={followContentLink}
                    references={refs}
                />
            );
        } else if (contentItem.nodeTypeAlias.equals('reactPhoto')) {
            const enableImageOverlay = contentItem?.enableImageOverlay;

            if (enableImageOverlay) {
                return <Photo json={contentItem} width={840} />;
            } else {
                const imagePath = contentItem?.image?.cdnImagePath;

                return <CdnImage uri={imagePath} wrapperStyle={{ flex: 1 }} />;
            }
        } else if (contentItem.nodeTypeAlias.equals('reactCornerBlockWYSIWYG')) {
            const { key, ...props } = contentItem;
            return <CornerblockWYSIWYG key={key} {...props} backgroundColor={Utils.applyColor(backgroundColor)} textColor={Utils.applyColor(textColor)} />;
        }

        return null;
    };

    const renderColumns = () => {
        const contentItemsArray = Object.values(contentItems);

        if (contentItemsArray.length === 1 || renderSingle) {
            return (
                <View style={ styles.container } dataSet={{ umbracoComponentName: nodeTypeAlias }}>
                    {renderContentItem(contentItemsArray[0])}
                </View>
            );
        } else if (contentItemsArray.length >= 2) {
            return (
                <View style={[{ flexDirection: 'row' }, styles.container]} dataSet={{ umbracoComponentName: nodeTypeAlias }}>
                    <View style={{ flex: 0.5 }}>{renderContentItem(contentItemsArray[0])}</View>
                    <View style={{ flex: 0.5 }}>{renderContentItem(contentItemsArray[1])}</View>
                </View>
            );
        }

        return null;
    };

    if (!contentItems) {
        return null;
    }

    return renderColumns();
};

Cornerblock.propTypes = {
    backgroundColor: PropTypes.string,
    contentItems: PropTypes.object,
    id: PropTypes.string.isRequired,
    textColor: PropTypes.string
};

export default Cornerblock;

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        maxHeight: '50vh' /* keep the corner block from bunching up during 3up to 2up transition @jacksonkr */
    }
})
